export default __webpack_public_path__ + "static/media/subscribe-closed.cf4b7fe4.svg";